'use client'

import React from 'react'

export interface CurrencyProps extends React.HTMLAttributes<HTMLSpanElement> {
  dollars: string | number
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const Currency = React.forwardRef<HTMLSpanElement, CurrencyProps>(
  (props: CurrencyProps, ref) => {
    const { dollars } = props
    let formattedValue = ''

    if (typeof dollars === 'number') {
      formattedValue = formatter.format(dollars)
    }

    if (typeof dollars === 'string') {
      formattedValue = formatter.format(parseFloat(dollars))
    }

    return (
      <span {...props} ref={ref}>
        {formattedValue}
      </span>
    )
  }
)

Currency.displayName = 'Currency'

export { Currency }
